import { Close } from "@mui/icons-material"
import { Divider, Grid, Paper, Slide, Typography } from "@mui/material"
import { ConnectButton } from "@rainbow-me/rainbowkit"
import React from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { Logo } from "../assets"
import { DiscordIcon, MenuLeftIcon, RewardsIcon, XIcon } from "../assets/icons"
import { Button } from "./commons"
import { siteMap, socialLinks } from "./commons/constants"
import { PointsPopover } from "./rewards"

const NavBar = () => {
  const [open, setOpen] = React.useState(false)
  const [openPointsDialog, setOpenPointsDialog] = React.useState(false)
  const points = 0
  const history = useNavigate()
  const location = useLocation()
  const navigateTo = (route: string) => {
    setOpen((prev) => !prev)
    history(route)
  }

  // const points = 0

  const handleMenuClick = (path?: string) => {
    setOpen((prev) => !prev)
    if (path) navigateTo(path)
  }

  const handleOpenPointsDialog = () => {
    setOpenPointsDialog((prev) => !prev)
  }

  return (
    <div style={{
      display: 'flex', color: 'white',
      padding: '1rem 0.8rem', paddingRight: '1rem',
      alignItems: 'center',
      placeContent: 'space-between',
      marginBottom: '1.5rem'
    }}>
      <div>
        <Button onClick={() => handleMenuClick()} transparent sx={{ padding: '0px 0px', margin: 0, minWidth: 0, border: 0 }}>
          <MenuLeftIcon style={{ marginTop: 2 }} />
        </Button>
      </div>
      <div className="rainbowConnectButton" style={{ display: 'flex', gap: '1rem', justifySelf: 'flex-end', alignSelf: 'center' }}>
        <div style={{ display: 'flex', gap: '1rem', justifySelf: 'flex-end', alignSelf: 'center' }}>
          <Button color="secondary" variant='contained' sx={{ minWidth: '5rem' }} onClick={() => handleOpenPointsDialog()}>
            <Grid container alignItems={'center'} justifyItems={'center'}>
              <RewardsIcon />
              <Typography color='brand.primary' component={'span'} sx={{ marginLeft: '0.5rem' }}>
                {points}
              </Typography>
            </Grid>
          </Button>
        </div>
        <ConnectButton label="Connect" />
      </div>
      {/* 
        <Button color="secondary" variant='contained' sx={{ minWidth: '5rem', width: '5rem', padding: 0 }}>
          <Grid container alignItems={'center'} justifyItems={'center'}>
            <WalletIcon style={{ marginTop: 2 }} />
            <ExpandMore sx={{ marginLeft: '0.5rem' }} />
          </Grid>
        </Button>
      </div> */}
      <Slide in={openPointsDialog} direction='up'>
        <Paper onClick={() => handleOpenPointsDialog()} sx={{
          position: 'absolute', top: 0, left: 0, height: '100vh', backgroundColor: 'transparent',
          zIndex: 4, padding: '1rem 2rem', width: '100dvw', backdropFilter: 'blur(2px)'
        }}>
          <Paper sx={{
            position: 'absolute', bottom: 0, left: 0, height: '40dvh',
            zIndex: 5, padding: '0rem 0.5rem', width: '100dvw'
          }}>
            <PointsPopover />
          </Paper>
        </Paper>
      </Slide>

      <Slide in={open} direction='right'>
        <Paper onClick={() => handleMenuClick()} sx={{
          position: 'absolute', top: 0, left: 0, height: '100vh', backgroundColor: 'transparent',
          zIndex: 4, padding: '1rem 2rem', width: '100dvw', backdropFilter: 'blur(2px)'
        }}>
          <Paper sx={{
            position: 'absolute', top: 0, left: 0, height: '100vh',
            zIndex: 5, padding: '1rem 1.5rem', width: '75dvw'
          }}>
            <Grid container>
              <Grid item container >
                <Grid item xs={8}>
                  <Logo style={{ maxWidth: '10rem', maxHeight: '4rem' }} onClick={() => handleMenuClick('/')} />
                </Grid>
                <Grid item xs={4} alignSelf={'center'} sx={{ textAlign: 'right' }}>
                  <Close onClick={() => handleMenuClick()} sx={{ color: 'text.secondary', zIndex: 10 }} />
                </Grid>
                <Grid item xs={12} sx={{ marginBottom: '1.5rem' }}>
                  <Divider sx={{ height: 1, width: '100%', backgroundColor: 'text.secondary' }} />
                </Grid>
              </Grid>
              <Grid item container flexDirection={'column'} justifyContent={'flex-start'} alignItems={'flex-start'} alignContent={'flex-start'}>
                {
                  Object.values(siteMap).filter((sites) => sites.display).map(({ path, name }, index) => {
                    const isSelected = ("/" + location?.pathname.split("/")[1]) === path
                    return (
                      <Button isSelected={isSelected} onClick={() => handleMenuClick(path)} key={index}
                        size='large' variant='text' sx={{ border: 0, padding: '0.5rem 0rem' }}>
                        <Typography variant="l">
                          {name}
                        </Typography>
                      </Button>
                    )
                  }
                  )
                }
              </Grid>
              <div style={{ position: 'absolute', bottom: 0, left: 0, width: '75dvw', padding: '1.5rem 1.5rem', zIndex: 11 }}>
                <Divider sx={{
                  height: 1, width: '100%',
                  backgroundColor: 'text.secondary', marginTop: 'auto'
                }} />
                <Grid item container sx={{ width: '100%', marginTop: '1rem' }} gap={2}>
                  <Link to={socialLinks.twitter} target='_blank' >
                    <XIcon />
                  </Link>
                  <Link to={socialLinks.discord} target='_blank' >
                    <DiscordIcon />
                  </Link>
                </Grid>
              </div>
            </Grid>
          </Paper>
        </Paper>
      </Slide>
    </div >
  )
}

export default NavBar